import { render } from "./oauth_callback.vue?vue&type=template&id=f514124c"
import script from "./oauth_callback.js?vue&type=script&lang=js&external"
export * from "./oauth_callback.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__